<div class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Trips Details</h3>
    </div>
    <mat-divider></mat-divider>
    <form action="" class="trips-popups">
      <div class="row mt-3 ml-0 mr-0">
        <div class="col-md-12">
          <div class="serial-no">{{ ordersView.trip_id }}</div>
          <div class="left-side">
            <h6>
              {{ ordersView.updatedAt | date : "dd-MM-yyyy" }},<span>{{
                ordersView.updatedAt | date : " hh:mm:ss a"
                }}</span>
            </h6>
          </div>

          <div class="right-side" *ngIf="ordersView?.userInfo?.user_type != 'corporate'">
            <!-- ₹{{ ordersView.driverRouteInfo[0]?.price | number : "1.2-2" }} -->
            ₹{{ ordersView.paymentInfo[0]?.price_details?.actual_price | number : "1.2-2" }}
          </div>
        </div>
      </div>
      <div class="row ml-0 mr-0">
        <div class="col-md-12">
          <div class="serial-no">Pickup Date:</div>
          <h6>{{ ordersView.pickup_date | date : "dd-MM-yyyy" }}</h6>
        </div>
        <div class="col-md-6" *ngIf="ordersView?.userInfo?.user_type != 'corporate'">
          <div class="left-side-bar">
            <p>Fare Breakup</p>
            <div class="row ml-0 mr-0">
              <div class="col-md-12">
                <div class="card-details card-details-total">
                  <div class="trip-details-left">Route Fare</div>
                  <div class="trip-details-right">
                    <!-- ₹{{ordersView.driverRouteInfo[0]?.route_fare | number : "1.2-2"}} -->
                    ₹{{ordersView.paymentInfo[0]?.price_details?.actual_price | number : "1.2-2"}}
                  </div>
                  <div>Deductions</div>
                  <div *ngFor="let order_tax of ordersView.paymentInfo[0]?.price_details?.transporter_tax_details">
                    <div class="card-details-left">
                      {{ order_tax.tax_name }} ({{ order_tax.tax_deduction }}
                      {{ order_tax.tax_type == "percent" ? "%" : "" }})
                    </div>
                    <div class="card-details-right trip_details" *ngIf="order_tax.tax_type == 'percent'">
                      ₹
                      {{
                      (ordersView.paymentInfo[0]?.price_details?.actual_price *
                      order_tax.tax_deduction) /
                      100
                      }}
                    </div>
                    <div class="card-details-right trip_details" *ngIf="order_tax.tax_type == 'amount'">
                      ₹
                      {{ order_tax.tax_deduction | number : "1.2-2" }}
                    </div>
                  </div>
                </div>
                <div class="trip-details-left">Total Fare</div>
                <div class="trip-details-left aditional-item">
                  (Route Fare after deductions)
                </div>
                <div class="trip-details-right">
                  <!-- ₹ {{ totalTax | number : "1.2-2" }} -->
                  ₹{{ finalFareAfterDeductions | number : "1.2-2" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0">
          <div class="col-md-6" *ngIf="ordersView.userInfo?.user_type === 'corporate'">
            <div class="left-side-bar">
              <p>Fare Breakup</p>
              <div class="row ml-0 mr-0">
                <div class="col-md-12">
                  <div class="card-details card-details-total">
                    <div class="trip-details-left">Route Fare</div>
                    <div class="trip-details-right">
                      ₹
                      {{
                      (ordersView.workOrderInfoInfo[0]?.pay_as_load_quantity === "loaded_quantity"
                      ? (ordersView.workOrderOtherDetails?.loading_point
                        ? ordersView.workOrderOtherDetails?.price_per_ton * ordersView.workOrderOtherDetails?.loading_point
                        : 0)
                      : (ordersView.workOrderOtherDetails?.unloading_point
                        ? ordersView.workOrderOtherDetails?.price_per_ton * ordersView.workOrderOtherDetails?.unloading_point
                        : (ordersView.workOrderOtherDetails?.loading_point
                          ? ordersView.workOrderOtherDetails?.price_per_ton * ordersView.workOrderOtherDetails?.loading_point
                          : 0))
                      ) | number : "1.2-2"
                      }}
                    </div>
                  </div>

                  <div class="alert alert-warning mt-3" *ngIf="
                      ordersView.workOrderInfoInfo[0]?.pay_as_load_quantity === 'unloaded_quantity' &&
                      !ordersView.workOrderOtherDetails?.unloading_point
                    " style="background-color: #fff3cd; border-color: #ffeeba; color: #856404; padding: 12px 20px; border-radius: 6px; font-weight: 500; font-size: 14px; display: flex; align-items: center; gap: 8px;">
                    <mat-icon style="font-size: 20px; width: 20px; height: 20px;">info</mat-icon>
                    <span>This is a temporary fare calculation based on the loading quantity. The actual fare will be updated after receiving the unloading quantity.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 serial-no">Trips Details:</div>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-5">
            <div class="serial-no">Truck Container:</div>
            <h6>{{ ordersView.truckCategory[0]?.truck_category_name }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Weight:</div>
            <h6>{{ ordersView.truckTypeInfo[0].truck_weight }}</h6>
          </div>
        </div>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-6">
            <div class="serial-no">Load Type:</div>
            <h6>{{ ordersView.material_type }}</h6>
          </div>
        </div>
        <div class="serial-no mt-3">Pickup and Dropoff Location:</div>
        <div class="location-payment mt-2">
          <!-- <img src="../../../assets/img/location-payment.svg" alt="" /> -->
          <div class="places">
            <div class="place-row">
              <mat-icon>near_me</mat-icon>
              <div class="place-text">
                <h4>{{ ordersView.pickup_details.from_city_name }}</h4>
                {{ ordersView.from_complete_address }}
                <div class="result">
                  Contact Details: {{ ordersView?.pickup_name }} - {{ ordersView?.pickup_contact }}
                </div>
              </div>
            </div>
            <div class="place-row" *ngFor="let stop of ordersView.stops; let i = index">
              <mat-icon>stop_circle</mat-icon>
              <div class="place-text">
                <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
                <div>{{ stop.complete_address }}</div>
                <div class="result">Contact Details: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}
                </div>
              </div>
            </div>
            <!-- Dropoff -->
            <div class="place-row">
              <mat-icon>location_on</mat-icon>
              <div class="place-text">
                <h4>{{ ordersView.dropoff_details?.to_city_name }}</h4>
                <div>{{ ordersView.to_complete_address }}</div>
                <div class="result">Contact Details: {{ ordersView?.dropoff_name }} - {{ ordersView?.dropoff_contact }}
                </div>
              </div>
            </div>
          </div>
          <!-- <span class="places">
            <span>
              <h4>{{ ordersView.pickup_details.from_city_name }}</h4>
              {{ ordersView.from_complete_address }}
            </span>
            <span>
              <h4>{{ ordersView.dropoff_details?.to_city_name }}</h4>
              {{ ordersView.to_complete_address }}
            </span>
          </span> -->
        </div>
        <!-- <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">Pickup Contact:</div>
            <h6>{{ ordersView.pickup_name }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Pickup Contact Number:</div>
            <h6>{{ ordersView.pickup_contact }}</h6>
          </div>
        </div>
        <div class="row mt-3 ml-0 mr-0">
          <div class="col-md-3">
            <div class="serial-no">Drop Off Contact:</div>
            <h6>{{ ordersView.dropoff_name }}</h6>
          </div>
          <div class="col-md-3">
            <div class="serial-no">Drop Off Contact Number:</div>
            <h6>{{ ordersView.dropoff_contact }}</h6>
          </div>
        </div> -->
        <div class="heading">
          <h3>Truck Details</h3>
        </div>
        <mat-divider></mat-divider>
        <div class="row">
          <div class="col-sm-3">
            <div class="head">Registration No:</div>
            <div class="result">
              {{ ordersView.truckInfo[0]?.truck_number }}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="head">Truck Type :</div>
            <div class="result">
              {{ ordersView.truckCategory[0]?.truck_category_name }}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="head">Truck Weight:</div>
            <div class="result">
              {{ ordersView.truckTypeInfo[0]?.truck_weight }}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="head">Truck ID:</div>
            <div class="result">
              {{ ordersView.truckInfo[0]?.truck_id }}
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div class="row">
          <div class="col-sm-3">
            <div class="head">Driver Name:</div>
            <div class="result">{{ ordersView.driverInfo[0]?.username }}</div>
          </div>
          <div class="col-sm-3">
            <div class="head">Driver Number:</div>
            <div class="result">
              {{ ordersView.driverInfo[0]?.mobile }}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="head">Driver ID :</div>
            <div class="result">
              {{ ordersView.driverInfo[0]?.driver_id }}
            </div>
          </div>
        </div>
      </div>
      <div class="heading mt-3" *ngIf="transporterHistory.length > 0">
        <h3>Transporter Payments Details:</h3>
      </div>
      <mat-divider *ngIf="transporterHistory.length > 0"></mat-divider>
      <div *ngFor="let transporter of transporterHistory; let i = index">
        <div class="row">
          <div class="serial-no mt-2">
            {{ i == 0 ? i + 1 : i }} Payment Details
          </div>
          <div class="row mt-3 ml-0 mr-0">
            <div class="col-md-3">
              <div class="serial-no">Transaction ID:</div>
              <h6>{{ transporter.transaction_id }}</h6>
            </div>
            <div class="col-md-3">
              <div class="serial-no">Paid Amount:</div>
              <h6>{{ transporter.transaction_amount }}</h6>
            </div>
            <div class="col-md-3">
              <div class="serial-no">Pay Mode:</div>
              <h6>Online</h6>
            </div>
            <div class="col-md-3">
              <div class="serial-no">Pay Date:</div>
              <h6>{{ transporter.payment_date | date : "dd-MM-yyyy" }}</h6>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb mt-4 mr-0 ml-0" *ngIf="Trip_History?.length > 0">
        <div class="heading mt-3">
          <h3>Trip History</h3>
        </div>
        <mat-divider></mat-divider>
        <div class="location-payment-2 mt-2" *ngFor="let history of Trip_History; let i = index">
          <img src="../../../assets/img/dots.svg" *ngIf="Trip_History.length - 1 != i" />
          <img src="../../../assets/img/dot_only.svg" *ngIf="Trip_History.length - 1 == i" />
          <span class="places-2">
            <span>
              <h4>{{ history.message }}:</h4>
              <h6>
                {{ history.date | date : "dd MMMM, yyyy" }}
                &nbsp;&nbsp;&nbsp;
                {{ history.date | date : "h:mm a" }}
              </h6>
            </span>
          </span>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="row ml-0 mr-0">
        <div class="col-md-12 d-flex justify-content-end align-items-center">
          <button type="button" class="buttonBlue" (click)="consignment(ordersView)">
            S9 Debit Note
          </button>
        </div>
      </div>
    </form>
  </div>
</div>